import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import { getState } from '~src/state';
import { calculateFormatDpi, resizeDimensions } from '~loader/loader-utils';
import { getSelectedPagesByUser } from './getSelectedPagesByUser';
import { getImageFromPage } from './getImageFromPage';
import { px2cm } from '~src/utils/units';
import { addWatermark } from '~src/utils';
import { getUser } from '~src/user';

const mapOrientationToPdf = {
  h: 'l', // landscape
  v: 'p', // portrait
};

export const makePDF = async () => {
  const { user } = await getUser();
  const selectedPagesByUser = getSelectedPagesByUser();
  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');
  const orientation =
    format && format.orientation
      ? format.orientation
      : formatDefault.orientation;
  const dpi = calculateFormatDpi(
    {
      editor_project_formats_pointer: format,
      editor_project_formats_default_pointer: formatDefault,
    },
    window.editorLoader?.sourceDPI || formatDefault?.dpi || 300
  );
  const pdfOrientation = mapOrientationToPdf[orientation];

  const { width, height } = resizeDimensions(
    format.width || formatDefault.width,
    format.height || formatDefault.height,
    window.editorLoader.defaultDPI,
    dpi
  );

  const pdf = new jsPDF(pdfOrientation, 'mm', [
    px2cm(width, dpi) * 10,
    px2cm(height, dpi) * 10,
  ]);

  let pageNumber = 0;
  for (let page of selectedPagesByUser) {
    pageNumber++;

    if (pageNumber > 1) {
      pdf.addPage();
    }

    let image = await getImageFromPage(page);
    if (user.org_pointer.tipo_istanza === 'demo') {
      Swal.fire({
        text: "Sto generando l'immagine...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: '#278e8e',
        didOpen: () => {
          Swal.showLoading();
        },
      });
      image = await addWatermark(image);
    }

    pdf.addImage(
      image,
      'JPEG',
      0,
      0,
      px2cm(width, dpi) * 10,
      px2cm(height, dpi) * 10
    );
  }

  return pdf;
};
